import BookingSummary from "components/Creation/components/Confirm/components/BookingSummary";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useAPI from "hooks/useAPI";
import Cost from "components/Creation/components/Confirm/components/BookingSummary/components/Cost";

const Booking = ({}) => {
  const { id } = useParams();
  const [booking, setBooking] = useState(null);
  const [user, setUser] = useState(null);
  const { API } = useAPI({});
  useEffect(() => {
    console.log("Booking page loaded");
    console.log("bookingId", id);
    getAndSetBooking();
  }, [id]);
  const getAndSetBooking = async () => {
    const data = await API.get(`/admin/bookings/${id}`);
    setBooking(data?.booking);
  };

  useEffect(() => {
    if (booking?.user?._id) {
      getAndSetUser(booking?.user?._id);
    }
  }, [booking]);

  const getAndSetUser = async (userId) => {
    const data = await API.get(`/admin/users/${userId}`);
    setUser(data?.user);
  };
  return (
    <div>
      <div className="container mx-auto p-8">
        <h1 className="text-center">Booking</h1>
        {user && (
          <div className="w-6/12 mx-auto mt-8 pb-8">
            <h4>User Details:</h4>
            {Object.keys(user).map((key) => {
              let value = user[key];
              if (typeof value === "object") {
                value = JSON.stringify(value);
              } else if (typeof value === "boolean") {
                value = value ? "Yes" : "No";
              }
              return (
                <div className="flex gap-4">
                  <span className="font-black">{key}:</span>
                  <span>{value}</span>
                </div>
              );
            })}
          </div>
        )}
        {booking && (
          <div className="p-8">
            <BookingSummary booking={booking} selection={booking.selection} />
            <br />
            <Cost bookingId={booking._id} />
          </div>
        )}
      </div>
    </div>
  );
};

export default Booking;
